import type from './libs/type';

const routes = require('./routes.json');
const baseUrl = '';

export default function(...args) {
    const name = args.shift();

    if (routes[name] === undefined) {
        console.error('Unknown route ', name);
    }
    else {
        return baseUrl + '/' + routes[name]
            .split('/')
            .map(s => s[0] == '{' ? typeof(args[0]) === 'string' ? args.shift() :s : s)
            .join('/')
            +(() => {
                let query = '';

                args.forEach(arg => {
                    if(type.isNotEmptyPlainObject(arg)) {
                        Object.keys(arg).forEach(i => {
                            query+= `${i}=${arg[i]}&`;
                        })
                    }
                });

                if(query) {
                    query = '?'+query;
                }

                return query;
            })();
    }
};